import AdfScannerIcon from '@mui/icons-material/AdfScanner';
import { Trans } from '@lingui/react/macro';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { NavMenuLink } from '@/features/navigation/components/nav-menu/subcomponents/nav-menu-link/NavMenuLink.tsx';

export function NavMenu() {
  return (
    <List>
      <ListItem disablePadding>
        <NavMenuLink to="/dispensers" label={<Trans>Dispensers</Trans>} icon={<AdfScannerIcon />} />
      </ListItem>
    </List>
  );
}
